import { render, staticRenderFns } from "./Tiny.vue?vue&type=template&id=4ea6aa89&"
import script from "./Tiny.vue?vue&type=script&lang=js&"
export * from "./Tiny.vue?vue&type=script&lang=js&"
import style0 from "./Tiny.vue?vue&type=style&index=0&id=4ea6aa89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports